import React from "react";
import "./KeyPorts.css";

const cards = [
  {
    title: "Gulf / UAE Ports",
    subtitle: "Strategic hub location",
    icon: "🌏",
  },
  {
    title: "China Ports",
    subtitle: "Consistent services",
    icon: "🇨🇳",
  },
  {
    title: "African Ports",
    subtitle: "Growing network",
    icon: "🌍",
  },
  {
    title: "UK / Europe Ports",
    subtitle: "Reliable ports",
    icon: "🇬🇧",
  },
  {
    title: "Global Support",
    subtitle: "Round the clock",
    icon: "⭐",
  },
];

export default function KeyPorts() {
  return (
    <section className="key-ports" id="key-ports">
      <div className="ports-container">
        <h2 className="section-title">Key Ports & Regions</h2>
        <p className="section-subtitle">
          Global shipping network with reliable port facilities
        </p>
        <div className="ports-grid">
          {cards.map((card, index) => (
            <article className="port-card" key={index}>
              <div className="port-icon">{card.icon}</div>
              <div className="port-body">
                <h3>{card.title}</h3>
                <p>{card.subtitle}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
